const baseUrl =
	(import.meta.env.VITE_API_BASE_URL as string | undefined) ||
	'https://3aa5gc94rf.execute-api.ap-southeast-2.amazonaws.com/dev';

async function http<T>(path: string, options: RequestInit): Promise<T> {
	const res = await fetch(`${baseUrl}${path}`, {
		...options,
		headers: {
			'Content-Type': 'application/json',
			...(options.headers || {})
		}
	});
	if (!res.ok) {
		const contentType = res.headers.get('content-type') || '';
		try {
			if (contentType.includes('application/json')) {
				const data = (await res.json()) as any;
				const msg =
					(typeof data?.message === 'string' && data.message) ||
					(typeof data?.error === 'string' && data.error) ||
					JSON.stringify(data);
				throw new Error(msg || `Request failed: ${res.status}`);
			} else {
				const text = await res.text();
				throw new Error(text || `Request failed: ${res.status}`);
			}
		} catch (e: any) {
			throw new Error(e?.message || `Request failed: ${res.status}`);
		}
	}
	return (await res.json()) as T;
}

export type Integration = {
	userId: string;
	integrationType: 'brewfather' | 'openai' | string;
	credentials?: {
		userId?: string;
		apiKey: string;
		[key: string]: any;
	};
	metadata?: Record<string, any>;
	createdAt: string;
	updatedAt: string;
};

/** Brewfather: userId + apiKey. OpenAI: apiKey only. */
export type IntegrationCredentials = {
	userId?: string;
	apiKey: string;
};

export const IntegrationService = {
	list: (userId: string, authHeader: Record<string, string>) =>
		http<{ items: Integration[] }>(`/integrations/${userId}`, {
			method: 'GET',
			headers: authHeader
		}),

	get: (userId: string, integrationType: string, authHeader: Record<string, string>) =>
		http<{ item: Integration }>(`/integrations/${userId}/${integrationType}`, {
			method: 'GET',
			headers: authHeader
		}),

	createOrUpdate: (
		userId: string,
		integrationType: string,
		credentials: IntegrationCredentials,
		authHeader: Record<string, string>
	) =>
		http<{ item: Integration }>(`/integrations/${userId}/${integrationType}`, {
			method: 'PUT',
			body: JSON.stringify(credentials),
			headers: authHeader
		}),

	delete: (userId: string, integrationType: string, authHeader: Record<string, string>) =>
		http<{ message: string }>(`/integrations/${userId}/${integrationType}`, {
			method: 'DELETE',
			headers: authHeader
		})
};
